import React from "react";
import { FaSearch } from "react-icons/fa";

export const JumpToPageIcon = ({ page, fn }) => (
  <FaSearch
    onClick={() => {
      fn(page);
    }}
    key="create"
    style={{ cursor: "pointer" }}
  ></FaSearch>
);
